import * as services from '@owl-nest/services'
import * as models from '@owl-nest/models'

export function useProject(
  slugOrId: string | number,
  extraFields: string[],
): services.project.UseProject<models.project.ProjectOwnerExtraFields> & {
  response: { data: models.project.ProjectForOwner }
} {
  const auth = services.user.useAuth()

  const projectService = services.project.useProject(slugOrId, {
    withToken: auth.type === 'loggedin',
    extraFields,
  })

  // atom should have been hydrated with server side data, so we are sure there is some data
  return projectService as unknown as services.project.UseProject<models.project.ProjectOwnerExtraFields> & {
    response: { data: models.project.ProjectForOwner }
  }
}
